import { BrowserRouter, Routes, Route } from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import AfterLoginPage from "./pages/AfterLoginPage";
import HomePage from "./pages/HomePage";
import AuthGuard from "./components/AuthGuard";
import AutoLoginPage from "./pages/AutoLoginPage";
function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LoginPage />} />

        {/* 🔒 Protected Routes */}
        <Route
          path="/after-login"
          element={
            <AuthGuard>
              <AfterLoginPage />
            </AuthGuard>
          }
        />
<Route path="/auto-login" element={<AutoLoginPage />} />
        <Route
          path="/home"
          element={
            <AuthGuard>
              <HomePage />
            </AuthGuard>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;